export const BOOKING_CONS_TYPE = 'BOOKING_CONS_TYPE'
export const PAYMENT_MODE_TABLEDATA = 'PAYMENT_MODE_TABLEDATA'
export const PICKUP_AND_DROPOFF = 'PICKUP_AND_DROPOFF'
export const FOC_APPR_LIST = 'FOC_APPR_LIST'
export const FOC_APPR_CONS_TYPE_DATA = 'FOC_APPR_CONS_TYPE_DATA'
export const MOP_TBL_DATA = 'MOP_TBL_DATA'
export const GS_DOCUMENTS_CHARGE = 'GS_DOCUMENTS_CHARGE'
export const GS_VALUATION_CHARGE_TABLE = 'GS_VALUATION_CHARGE_TABLE'
export const GS_EDIT_VALUATION_CHARGE_DETAIL = 'GS_EDIT_VALUATION_CHARGE_DETAIL'
export const AUTO_Del_TBL_DATA = 'AUTO_Del_TBL_DATA'
export const AUTO_RECEIVE_TBL_DATA = 'AUTO_RECEIVE_TBL_DATA'
export const AUTO_BRNCH_TRANS_RECV_TBL_DATA = 'AUTO_BRNCH_TRANS_RECV_TBL_DATA'
export const AUTO_BRNCH_TRANS_RECV_FILTERS = 'AUTO_BRNCH_TRANS_RECV_FILTERS'
export const Label_LIST = 'UPDATE_Label_LIST'
export const TICKET_FORMAT_LIST = 'TICKET_FORMAT_LIST'
export const MONTHLY_TARGET_TABLE_DATA = 'MONTHLY_TARGET_TABLE_DATA'
export const GST_VALIDATION_DATA = 'GST_VALIDATION_DATA'
export const GST_INV_CONFIG_DATA = 'GST_INV_CONFIG_DATA'
export const DESTCITY_WITH_CROSSING_BRANCH = 'DESTCITY_WITH_CROSSING_BRANCH'
export const CITY_LIST_F0R_CROSSING_MASTER = 'CITY_LIST_F0R_CROSSING_MASTER'
export const PARTY_CONFIG_TBL_DATA = 'PARTY_CONFIG_TBL_DATA'
export const SERVICE_TYPE_LIST_ALL_TABLE_DATA = 'SERVICE_TYPE_LIST_ALL_TABLE_DATA'
export const KG_KM_RATE_MATRIX_DATA = 'KG_KM_RATE_MATRIX_DATA'
export const SERVICE_TYPE_LIST_ALL_DATA = 'SERVICE_TYPE_LIST_ALL_DATA'
export const KG_KM_RATE_MATRIX_HISTORY_DATA = 'KG_KM_RATE_MATRIX_HISTORY_DATA'
export const SERVICE_TYPE_LIST_ALL2_DATA = 'SERVICE_TYPE_LIST_ALL2_DATA'
export const KG_KM_DOC_CHRG_DATA = 'KG_KM_DOC_CHRG_DATA'
export const CARGO_CITY_LIST = 'CARGO_CITY_LIST'
export const PARTY_MASTER_LIST_ALL = 'PARTY_MASTER_LIST_ALL'
